import React, { useState } from 'react';
import './Admin.css';

const API_URL = 'https://whaleverse-production.up.railway.app';
const ADMIN_PASSWORD = 'pengu2025';

function Admin() {
  const [password, setPassword] = useState('');
  const [announcementText, setAnnouncementText] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSetAnnouncement = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    if (password !== ADMIN_PASSWORD) {
      setMessage('❌ Invalid admin password');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/config`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          key: 'announcement',
          value: announcementText
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(`✅ Announcement updated successfully!`);
        setPassword('');
      } else {
        setMessage(`❌ Error: ${data.detail || 'Failed to update announcement'}`);
      }
    } catch (error) {
      setMessage(`❌ Network error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-container">
      <div className="admin-panel">
        <h1>🎮 BearWorld Admin Panel</h1>
        <p className="subtitle">Set Global Announcement</p>
        
        <form onSubmit={handleSetAnnouncement}>
          <div className="form-group">
            <label>Admin Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
            />
          </div>

          <div className="form-group">
            <label>Announcement Text</label>
            <textarea
              value={announcementText}
              onChange={(e) => setAnnouncementText(e.target.value)}
              placeholder="Enter announcement text (leave empty to clear)"
              rows="4"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #ddd',
                borderRadius: '6px',
                fontSize: '16px',
                boxSizing: 'border-box',
                resize: 'vertical',
                fontFamily: 'inherit'
              }}
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Updating...' : 'Set Announcement'}
          </button>
        </form>

        {message && (
          <div className={`message ${message.startsWith('✅') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}

        <div className="info">
          <p><strong>Note:</strong> This announcement will be displayed to all players at the top of the game.</p>
        </div>
      </div>
    </div>
  );
}

export default Admin;
